var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          { staticClass: "left-box" },
          [
            _c("menuTree", {
              ref: "menuTree",
              on: {
                createNote: _vm.addCreate,
                frameId: _vm.getFrameId,
                onRecently: _vm.onRecently,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "middle-box" }, [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c("el-input", {
                staticClass: "search-input",
                attrs: {
                  placeholder: _vm.$t("calendar.placeholder01"),
                  clearable: "",
                  size: "small",
                  "suffix-icon": "el-icon-search",
                },
                on: { change: _vm.changeSearch },
                model: {
                  value: _vm.goodData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.goodData, "title", $$v)
                  },
                  expression: "goodData.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "main" }, [
            !_vm.recently
              ? _c("div", [
                  _vm.memorandum.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "content-ul px-14" },
                        _vm._l(_vm.memorandum, function (item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              class: index == _vm.itemIndex ? "active" : "",
                              on: {
                                click: function ($event) {
                                  return _vm.clickItem(index, item.id)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "title" },
                                [
                                  _c("span", [
                                    _c("i", {
                                      staticClass: "iconfont iconjishiben-01",
                                    }),
                                    _vm._v(" " + _vm._s(item.title)),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "pop-" + item.id,
                                      refInFor: true,
                                      attrs: {
                                        offset: 10,
                                        placement: "bottom-end",
                                        trigger: "click",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "right-item-list" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "right-item cursor-pointer mb-5",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.moveTo(item)
                                                },
                                              },
                                            },
                                            [_vm._v("移动到")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "right-item cursor-pointer",
                                              on: { click: _vm.delMemorandum },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "iconfont icongengduo right-icon",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "comment" }, [
                                _vm._v(_vm._s(_vm.getStringHtml(item.content))),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "foottime" }, [
                                _vm._v("创建于 " + _vm._s(item.created_at)),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.memorandum.length && !_vm.loadingPage
                    ? _c("div", { staticClass: "default-page px-10" }, [
                        _c("div", { staticClass: "content" }, [
                          _c(
                            "div",
                            { staticClass: "content-list" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/none-007.png"),
                                  alt: "",
                                },
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "text-center" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("public.message09")) + "~"
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "mt20",
                                  attrs: { size: "small", type: "primary" },
                                  on: { click: _vm.addMemorandum },
                                },
                                [_vm._v(" 新建记事本 ")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.recently
              ? _c(
                  "div",
                  {},
                  _vm._l(_vm.memorandum, function (j, i) {
                    return _c("div", { key: i }, [
                      _c(
                        "ul",
                        { staticClass: "content-ul px-10" },
                        [
                          _c("div", { staticClass: "recentlyMonth" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(j.month) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(j.data, function (item, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                class:
                                  item.id === _vm.itemIndex ? "active" : "",
                                on: {
                                  click: function ($event) {
                                    return _vm.clickItem(
                                      index,
                                      item.id,
                                      i,
                                      item.pid
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "title" },
                                  [
                                    _c("span", [
                                      _c("i", {
                                        staticClass: "iconfont iconjishiben-01",
                                      }),
                                      _vm._v(" " + _vm._s(item.title)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-popover",
                                      {
                                        ref: "pop-" + item.id,
                                        refInFor: true,
                                        attrs: {
                                          offset: 10,
                                          placement: "bottom-end",
                                          trigger: "click",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "right-item-list" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right-item cursor-pointer mb-5",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.moveTo(item)
                                                  },
                                                },
                                              },
                                              [_vm._v("移动到")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "right-item cursor-pointer",
                                                on: {
                                                  click: _vm.delMemorandum,
                                                },
                                              },
                                              [_vm._v("删除")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "iconfont icongengduo right-icon",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "comment" }, [
                                  _vm._v(
                                    _vm._s(_vm.getStringHtml(item.content))
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "foottime" }, [
                                  _vm._v(
                                    "\n                  编辑于\n                  " +
                                      _vm._s(
                                        _vm
                                          .$moment(item.updated_at)
                                          .format("MM-DD HH:mm:ss")
                                      ) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right-box" },
          [
            _c(
              "el-card",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingPage,
                    expression: "loadingPage",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.memorandum.length == 0,
                        expression: "memorandum.length == 0",
                      },
                    ],
                    staticClass: "noneDefault",
                  },
                  [
                    _c("img", {
                      staticClass: "img",
                      attrs: {
                        alt: "",
                        src: require("../../../assets/images/nodedef1.png"),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", [_vm._v("暂无笔记~")]),
                  ]
                ),
                _vm._v(" "),
                _vm.memorandum.length > 0
                  ? _c("div", { staticClass: "content" }, [
                      _c("div", { staticClass: "header flex" }, [
                        _c(
                          "div",
                          { staticClass: "edit-title" },
                          [
                            _c("el-input", {
                              staticClass: "edit-input",
                              attrs: {
                                placeholder: _vm.$t("calendar.placeholder02"),
                                size: "small",
                              },
                              on: { change: _vm.editTitle },
                              model: {
                                value: _vm.title,
                                callback: function ($$v) {
                                  _vm.title = $$v
                                },
                                expression: "title",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "savebutton" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  loading: _vm.saveLoading,
                                  size: "small",
                                  title: "保存(Ctrl+S)",
                                  type: "",
                                },
                                on: { click: _vm.edit },
                              },
                              [_vm._v("保存")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "edit-content" },
                        [
                          _c("ueditorFrom", {
                            ref: "ueditorFrom",
                            attrs: {
                              type: "notepad",
                              editorBorder: false,
                              content: _vm.content,
                              height: "calc(100vh - 126px)",
                            },
                            on: { input: _vm.ueditorEdit },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("move-dialog", {
        ref: "moveDialog",
        attrs: { "move-data": _vm.moveData },
        on: { handlerMove: _vm.handlerMove },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }